<template>
  <div class="profile__card">
    <h4 class="profile__title">Editar dados pessoais</h4>

    <p v-show="hasUpdated" class="success-form-msg">
      Seu perfil foi atualizado com sucesso!
      <BIconX @click="onCloseSuccessMessage" />
    </p>

    <form class="profile__form">
      <div class="profile__form-group">
        <div class="custom-form-control">
          <label>Nome completo</label>
          <input
            class="form-control"
            :class="[$v.user.name.$error ? 'form-control-invalid' : '']"
            type="text"
            placeholder="Nome"
            value="Camila Alcantra de Souza"
            v-model="$v.user.name.$model"
          />
          <div v-if="$v.user.name.$error">
            <p class="error" v-if="!$v.user.name.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Apelido</label>
          <input
            class="form-control"
            type="text"
            v-model="user.nickname"
          />
        </div>

        <div class="custom-form-control">
          <label>Email</label>
          <input
            class="form-control"
            v-model="$v.user.email.$model"
            type="email"
            placeholder="E-Mail"
            readonly
          />
        </div>

        <div class="custom-form-control">
          <label>Tipo Sanguineo</label>
          <select class="custom-select form-control" @change="onSetBloodType">
            <option>
              {{ user.blood_type }}
            </option>
            <option
              v-for="(blood_type, blood_type_index) in blood_types"
              :key="blood_type_index"
              :value="blood_type"
            >
              {{ blood_type }}
            </option>
          </select>
          <div v-if="$v.user.blood_type.$error">
            <p class="error" v-if="!$v.user.blood_type.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Data de nascimento</label>
          <input
            class="form-control"
            :class="[$v.user.birthday.$error ? 'form-control-invalid' : '']"
            type="tel"
            v-mask="'##/##/####'"
            v-model="$v.user.birthday.$model"
          />
          <div v-if="$v.user.birthday.$error">
            <p class="error" v-if="!$v.user.birthday.required">
              Campo obrigatório
            </p>
            <p
              v-if="!$v.user.birthday.minAge || !$v.user.birthday.maxAge"
              class="error"
            >
              Data inválida
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Peso</label>
          <input
            class="form-control"
            type="number"
            step="0.1"
            :class="[$v.user.weight.$error ? 'form-control-invalid' : '']"
            v-model="$v.user.weight.$model"
          />

          <div v-if="$v.user.weight.$error">
            <p class="error" v-if="!$v.user.weight.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Altura</label>
          <input
            class="form-control"
            :class="[$v.user.height.$error ? 'form-control-invalid' : '']"
            type="tel"
            v-mask="['#.## m']"
            v-model="$v.user.height.$model"
          />
          <div v-if="$v.user.height.$error">
            <p class="error" v-if="!$v.user.height.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Telefone</label>
          <input
            class="form-control"
            :class="[$v.user.phone_number.$error ? 'form-control-invalid' : '']"
            type="tel"
            v-mask="['(##) #####-####']"
            v-model="$v.user.phone_number.$model"
          />
          <div v-if="$v.user.phone_number.$error">
            <p class="error" v-if="!$v.user.phone_number.required">
              Campo obrigatório
            </p>
          </div>
        </div>
      </div>

      <button class="button3" @click.prevent="updateUserData">
        Salvar alterações
      </button>
    </form>
  </div>
</template>

<script>
import { userComputed, userMethods } from "../state/helpers";
import { required, maxLength, minLength, sameAs } from "vuelidate/lib/validators";
import { formatDate } from "./../utils/masks/formatSlotDate";
import { moreThan18y, differenceInYearsFromNow } from "./../utils/dates/format";

export default {
  name: "UserForm",
  data() {
    return {
      user: {},
      hasUpdated: false,
      loading: false,
      blood_types: ["A +", "B +", "AB +", "A -", "B -", "AB -", "O +", "O -"]
    };
  },
  validations: {
    user: {
      name: { required },
      email: { required },
      phone_number: { required },
      blood_type: { required },
      birthday: {
        required,
        minAge: function(value) {
          if (value.length == 10) return moreThan18y(value) > 18;

          return false;
        },
        maxAge: function(value) {
          if (value.length == 10) return differenceInYearsFromNow(value) < 150;

          return false;
        }
      },
      weight: { required },
      height: { required },
    }
  },
  mounted() {
    let user = Object.assign({}, this.$store.state.user.currentUser);
    this.user = user;
    if (this.user.birthday)
      this.user.birthday = formatDate(this.user.birthday, "dd/MM/yyyy");
  },
  methods: {
    ...userMethods,
    onSetBloodType($event) {
      this.user.blood_type = $event.target.value;
    },
    async updateUserData() {
      this.$v.$touch();

      if (this.$v.user.$invalid) return;

      const payload = Object.assign({}, this.user);
      this.loading = true;

      await this.updateUser(payload);

      this.hasUpdated = true;
      this.loading = false;
    },
    onCloseSuccessMessage() {
      this.hasUpdated = false;
    }
  }
};
</script>
